module.exports = __webpack_public_path__ + "img/spain.359530a5.svg";